/**
 * video JavaScript singleton module
 */

var video = (function($) {
  function initvideo() {
    const video = document.querySelector(".footer-logo__video");

    if (!video) return;

    let hasPlayed = false;

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !hasPlayed) {
            hasPlayed = true;

            video.play();
          }
        });
      },
      {
        threshold: 0.3
      }
    );

    observer.observe(video);

    // dejar de observar cuando termine
    video.addEventListener("ended", function() {
      observer.disconnect();
    });
  }

  function init() {
    // return early if no corresponding module present
    if (!$(".footer-logo__video").length) {
      return;
    }

    initvideo();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(video.init);
